import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { loginUser, logoutUser } from "../services/authService";
// import { tockenExchange } from "../services/authService";

const extractUserFromToken = (token) => {
  try {
    if (!token) return null;

    const decoded = jwtDecode(token);
    return {
      email: decoded.email,
      username: decoded.username,
      userId: decoded.uuid || decoded.userId,
      role: decoded.role,
      permissions: decoded.permissions,
    };
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

const initialState = {
  token: localStorage.getItem("token"),
  webToken: localStorage.getItem("webToken"),
  isAuthenticated: !!localStorage.getItem("token"),
  loading: false,
  error: null,
  user: extractUserFromToken(localStorage.getItem("token")),
};

export const login = createAsyncThunk("auth/login", async (credentials) => {
  try {
    const loginData = {
      email: credentials.email,
      password: credentials.password,
      confirmPassword: credentials.password,
    };

    const response = await loginUser(loginData);

    if (response.responseCode === 1) {
      const token = response.token;
      const user = extractUserFromToken(token);
      console.log("User data extracted from token:", user);
      // Store token
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      // Get web token (disabled)
      // tockenExchange(token)
      //   .then(async (webTokenResponse) => {
      //     if (webTokenResponse?.webToken) {
      //       const webToken = webTokenResponse.webToken;
      //       localStorage.setItem("webToken", webToken);
      //       return {
      //         token,
      //         webToken,
      //         user,
      //       };
      //     }
      //   })
      //   .catch((webTokenError) => {
      //     console.error("Error getting web token:", webTokenError);
      //   });
      // if (webTokenResponse.ok) {
      //     const webTokenData = await webTokenResponse.json();
      //     const webToken = webTokenData.webToken;
      //     localStorage.setItem('webToken', webToken);
      //     return {
      //         token,
      //         webToken,
      //         user
      //     };
      // }
      return {
        token,
        user,
      };
    } else {
      throw new Error(response.responseMessage || "Login failed");
    }
  } catch (error) {
    console.error("Login error in thunk:", error);
    throw error.response?.data || error.message || "Login failed";
  }
});

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await logoutUser();

      localStorage.removeItem("token");
      localStorage.removeItem("webToken");
      localStorage.removeItem("user");

      return response;
    } catch (error) {
      localStorage.removeItem("token");
      localStorage.removeItem("webToken");
      localStorage.removeItem("user");
      return rejectWithValue(
        error.response?.data || error.message || "Logout failed"
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    updateUserData: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    refreshUserFromToken: (state) => {
      const token = localStorage.getItem("token");
      if (token) {
        state.user = extractUserFromToken(token);
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.token = action.payload.token;
        state.webToken = action.payload.webToken;
        state.user = action.payload.user;
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.token = null;
        state.webToken = null;
        state.user = null;
        state.error = action.error.message || "Login failed";
      })
      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.token = null;
        state.webToken = null;
        state.user = null;
        state.error = null;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Logout failed";
        state.isAuthenticated = false;
        state.token = null;
        state.webToken = null;
        state.user = null;
      });
  },
});

export const { clearError, setUser, updateUserData, refreshUserFromToken } =
  authSlice?.actions;
export default authSlice.reducer;
